module.exports = {"TXTWCL_All_Markets":{"id":"TXTWCL_All_Markets","defaultMessage":"Todos os Mercados"}}